import baseRoute from '../baseRoute';

type RouteDefinition = (
	`${typeof baseRoute}/:materialId/scheduled`
	| `${typeof baseRoute}/${number}/scheduled`
);

export const ROUTE: RouteDefinition = `${baseRoute}/:materialId/scheduled`;

export const URL = (materialId: number): RouteDefinition => `${baseRoute}/${materialId}/scheduled`;
